import axios from 'axios';
import store from '../store';

axios.defaults.baseURL = API_BASE_URL;

function createAuthHeader(params = null) {
  let tmp = {
    headers: {
      'Authorization': 'Bearer ' + store.getters.token
    }
  };
  tmp.params = params;
  return tmp;
}

export default {
  get(url, params) {
    return axios.get(url, createAuthHeader(params));
  },
  post(url, body) {
    return axios.post(url, body, createAuthHeader());
  },
  put(url, body) {
    return axios.put(url, body, createAuthHeader());
  },
  delete(url, body) {
    return axios.delete(url, {
      headers: createAuthHeader().headers,
      data: body
    });
  },
  registerUser(username, email, password, confirmPassword, firstName, lastName, companyName, roles, auid) {
    let body = {
      Username: username,
      Email: email,
      Password: password,
      ConfirmPassword: confirmPassword,
      FirstName: firstName,
      LastName: lastName,
      CompanyName: companyName,
      Roles: roles,
      Auid: auid
    };
    return axios.post('/register', body);
  },
  createUser(username, password, confirmPassword, roles) {
    let body = {
      Username: username,
      Password: password,
      ConfirmPassword: confirmPassword,
      Roles: roles
    };
    return axios.post('/users', body, createAuthHeader());
  },
  runSimulation(body, options = {}) {
    const {
      storeScenario = false,
      scenarioName = null,
      useShallowResponse = false
    } = options;
    let url = 'simulate' + ((storeScenario && scenarioName) ? `/save_scenario/${scenarioName}` : '');
    if (useShallowResponse) {
      url += '?useShallowResponse=true';
    }
    return this.post(url, body);
  },
  runPiceYieldSpread(type, body, useLoanLevel) {
    let url = 'simulate/' + type.toLowerCase();
    if (useLoanLevel) {
      url += '?loanLevel=true';
    }
    return this.post(url, body);
  },
  runMatirxPiceYieldSpread(type, body, useLoanLevel) {
    let url = 'simulate/' + type.toLowerCase() + '/matrix';
    if (useLoanLevel) {
      url += '?loanLevel=true';
    }
    return this.post(url, body);
  },
  getCustomDeal(dealId, _export = false) {
    return this.get(`/deals/custom/${dealId}?export=${_export}`);
  },
  createCustomCIRTDeal(dealPayload) {
    return this.post(`/deals/custom/cirt`, dealPayload);
  },
  updateCustomCIRTDeal(dealId, dealPayload) {
    return this.put(`/deals/custom/cirt/${dealId}`, dealPayload);
  },
  createCustomSTACRACISDeal(dealPayload) {
    return this.post(`/deals/custom/stacr_acis`, dealPayload);
  },
  updateCustomSTACRACISDeal(dealId, dealPayload) {
    return this.put(`/deals/custom/stacr_acis/${dealId}`, dealPayload);
  },
  deleteCustomDeal(dealId) {
    return this.delete(`/deals/custom/${dealId}`);
  },
  getUserDeals(_export = false) {
    return this.get(`/deals?export=${_export}`);
  },
  getDealDetails(dealName, settlementDate = null) {
    return this.get(`/deals/${dealName}` + ((settlementDate != null) ? `/${settlementDate}` : ''));
  },
  getDealsNames() {
    return this.get('/deals/names');
  },
  getUserDealsNames() {
    return this.get('/deals/userDealsNames');
  },
  getAcisDealStructure(dealName) {
    return this.get('/deals/' + dealName + '/acis');
  },
  getUsers() {
    return this.get('/users');
  },
  getUser(username) {
    return axios.get('/users/' + username, createAuthHeader());
  },
  updateUser(userId, isEnabled) {
    return axios.put('/users/' + userId, {
      IsEnabled: isEnabled
    }, createAuthHeader());
  },
  deleteUser(userId) {
    return axios.delete('/users/' + userId, createAuthHeader());
  },
  getRoles() {
    return this.get('/roles');
  },
  editRoles(userId, roles) {
    return this.put('/users/' + userId + '/roles', roles);
  },
  editDeals(userId, deals) {
    return this.put('/users/' + userId + '/deals', deals);
  },
  resetPassword(userId) {
    return this.post('/users/reset', { UserId: userId });
  },
  authenticate(username, password) {
    var params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    params.append('grant_type', 'password');
    return axios.post('/oauth/token', params);
  },
  changePassword(oldPassword, newPassword, confirmNewPassword) {
    return this.put('/passwords', {
      OldPassword: oldPassword,
      NewPassword: newPassword,
      ConfirmPassword: confirmNewPassword
    });
  },
  getUserVectors() {
    return this.get('/vectors');
  },
  saveVectors(body) {
    return this.post('/vectors', body);
  },
  assignDealToAll(dealName) {
    return this.put('/administrator/deal/' + dealName + '/assign_all');
  },
  removeDealFromAll(dealName) {
    return this.delete('/administrator/deal/' + dealName + '/remove_all');
  },
  getPortfolios() {
    return this.get('/portfolios/');
  },
  getPortfolioByName(name) {
    return this.get('/portfolios/' + name);
  },
  getPortfolioScenarios(id, vendor) {
    return this.get('/portfolios/' + id + '/scenarios', {
      vendor: vendor
    });
  },
  runPortfolio(reqBody) {
    return this.post('/simulate/portfolio', reqBody);
  },
  savePortfolioAnalysis(reqBody) {
    return this.post('/simulate/portfolio/save', reqBody);
  },
  savePortfolios(body) {
    return this.post('/portfolios/bulk', body);
  },
  updatePortfolio(id, body) {
    return this.put('/portfolios/' + id, body);
  },
  deletePortfolios(ids) {
    return this.delete('/portfolios/bulk', ids);
  },
  addPortfolio(body) {
    return this.post('/portfolios/', body);
  },
  sendContactRequest(body) {
    return this.post('/contact', body);
  },
  getCollateralHistory(dealName) {
    return this.get('/deals/' + dealName + '/collateral/history');
  },
  getCollateralReport(dealName, groupByField) {
    return this.get('/deals/' + dealName + '/collateral/' + groupByField + '/report');
  },
  getCollateralRemitHistory(dealName) {
    return this.get('/deals/' + dealName + '/collateral/remitHistory');
  },
  getBondRemitHistory(dealName, bondName) {
    return this.get('/deals/' + dealName + '/bonds/' + bondName + '/remitHistory');
  },
  getUserCollateralCashflows(dealName = '', vendor = '', collateralMonth = '', scenarioName = null) {
    return this.get('/usercollcashflow', {
      dealName: dealName,
      vendor: vendor,
      collateralMonth: collateralMonth,
      scenarioName: scenarioName
    });
  },
  saveUserCollateralCashflows(body) {
    return this.post('/usercollcashflow/', body);
  },
  getUserScenarios(dealName, vendorName) {
    return this.get('/scenarios', {
      dealName: dealName,
      vendor: vendorName
    });
  },
  getUserScenariosNoVectors() {
    return this.get('/scenarios/list');
  },
  getUserScenarioById(id) {
    return this.get('/scenarios/' + id);
  },
  getDealNamesForAvailableUserScenarios() {
    return this.get('/scenarios/names');
  },
  async getVendorsForAvailableUserScenarios() {
    let res = await this.get('/scenarios/vendors');
    if (res.status == 200) {
      return res.data;
    }
    return [];
  },
  async getVendorsForAvailableUserCashflows() {
    let res = await this.get('/usercollcashflow/vendors');
    if (res.status == 200) {
      return res.data;
    }
    return [];
  },
  async getVendorsForAvailableUserScenariosAndCashflows() {
    let scenarioVendors = await this.getVendorsForAvailableUserScenarios();
    let cashflowVendors = await this.getVendorsForAvailableUserCashflows();
    return scenarioVendors.concat(cashflowVendors.filter((item) => scenarioVendors.indexOf(item) < 0)).sort();
  },
  saveUserScenarios(scenarios, mode) {
    const body = {
      Scenarios: scenarios,
      SaveMode: mode
    };
    return this.post('/scenarios/bulk', body);
  },
  removeUserScenarios(ids) {
    return this.delete('/scenarios/bulk', ids);
  },
  shareUserScenarios(arrScenarioIds, arrUserIds) {
    return this.post('/scenarios/bulk/share', { scenarioIds: arrScenarioIds, userIds: arrUserIds });
  },
  updateUserScenario(id, body) {
    return this.put('/scenarios/' + id, body);
  },
  getAllScenarios(userId) {
    return this.get(`/administrator/user/${userId}/scenarios`);
  },
  assignScenariosToUser(body, userId) {
    return this.post(`/administrator/user/${userId}/scenarios`, body);
  },
  getAllDeals(userId) {
    return this.get(`/administrator/user/${userId}/deals`);
  },
  // ##################################################
  // region Reports
  getReports() {
    return this.get(`/report`);
  },
  getReportsList() {
    return this.get(`/report/list`);
  },
  getHistoricalReportsList() {
    return this.get(`/report/historical/list`);
  },
  getReportById(id) {
    return this.get(`/report/${id}`);
  },
  getHistoricalReportById(id) {
    return this.get(`/report/historical/${id}`);
  },
  saveReport(id = 0, body) {
    return this.post(`/report/${id}`, body);
  },
  deleteReport(id) {
    return this.delete(`/report/${id}`);
  },
  getCalculations() {
    return this.get(`/report/calculations`);
  },
  runReport(id, body) {
    return this.put(`/report/${id}/run`, body);
  },
  runHistoricalReport(id, body) {
    return this.put(`/report/historical/${id}/run`, body);
  },
  // endregion Reports
  // ##################################################
  assignDealsToUser(body, userId) {
    return this.post(`/administrator/user/${userId}/deals`, body);
  },
  getCollateralDataUrl(fileName, month) {
    return this.get(`documentation/loan/${fileName}/month`);
  },
  getDealAndBondIdByCusip(cusip) {
    return this.get('deals/idByCusip/' + cusip);
  },
  checkIfUserExistsByAuid(auid) {
    return this.get('register/checkIfUserIsRegistered/' + auid);
  },
  logTrialAccess(queryParameters) {
    let body = {
      Auid: queryParameters.auid,
      Cusip: queryParameters.utm_term,
      Referrer: queryParameters.utm_source,
      Campaign: queryParameters.utm_campaign,
      Medium: queryParameters.utm_medium,
      Price: queryParameters.price,
      LossSeverity: queryParameters.loss_severity,
      Delinquency: queryParameters.delinquency,
      IndexRate: queryParameters.libor,
      SettlementDate: queryParameters.settle_dt
    };
    return this.post('register/logAccess', body);
  },
  log(level, message, stacktrace) {
    return this.post('/log', {
      level: level,
      message: message,
      stacktrace: stacktrace
    });
  }
};
